import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import {
  subValue as subValueStyles,
  statItemStyles,
  statTitle,
  statValue,
  statWrapper,
} from "./statsItem.css";
import { ReactNode, useId } from "react";

interface StatsListProps {
  title: ReactNode;
  value?: number | string;
  subValue?: string;
}

const StatItem = ({ title, value, subValue }: StatsListProps) => {
  const { notApplicableAbbreviation } = usePlosTranslations();
  const id = useId();
  const titleId = `stat-title-${id}`;
  const valueId = `stat-value-${id}`;

  return (
    <li className={statItemStyles} aria-labelledby={`${titleId} ${valueId}`}>
      <div className={statWrapper}>
        <span className={statTitle} id={titleId}>
          {title}
        </span>
        <span className={statValue} id={valueId}>
          {value ?? notApplicableAbbreviation}
        </span>
        {subValue && <span className={subValueStyles}>{subValue}</span>}
      </div>
    </li>
  );
};

export default StatItem;
